export default function auth ({ next, store, to }){
  if (!store.state.auth.user) {
    return next({
      name: 'login',
      query: to.query
    })
  }

  return next()
}